import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyle = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    '& > img': {
      height: '100%',
    },
  },
}))
const UnderDevelopment = () => {
  const classes = useStyle()
  return <div className={classes.root}><img src="/images/under-development.svg" alt="under construction" /></div>
}

export default UnderDevelopment
